<template>
  <li
    :class="classList"
    @click="header.isSortable ? $emit('sort', header.name) : null"
    :tabindex="header.isSortable ? '0' : '-1'"
  >
    <span class="st-table-item-header__text">{{ header.name }}</span>
    <span class="st-table-item-header__icon" v-if="header.isSortable">
      <component
        :is="icon"
        :size="'xs'"
        name="arrow-down"
        :alt="header.name"
        useSvg
        inline
      />
    </span>
  </li>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";
import { version } from "vue";

export default {
  name: "st-table-item-header",
  components: {
    StIcon,
    StIconLegacy,
  },
  props: {
    header: Object,
  },
  computed: {
    classList: function() {
      return [
        "st-table-item-header",
        this.header.isSortable && "st-table-item-header--is-sortable",
      ];
    },
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-table-item-header {
  display: flex;
  margin: 0;
  padding: rem-calc(20);
  flex: 1;
  &--is-sortable {
    cursor: pointer;
  }
  &__icon {
    margin-left: rem-calc(10);
  }
}
</style>
